import { cn } from '@/lib/utils';
import type { WatchForOutcome } from '@/lib/api';

const tones: Record<WatchForOutcome, string> = {
  pass: 'border-success/30 bg-success/10 text-success',
  fail: 'border-destructive/30 bg-destructive/10 text-destructive',
  'n/a': 'border-border bg-muted text-muted-foreground',
};

export function OutcomePill({ outcome }: { outcome: WatchForOutcome }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium uppercase tracking-wide',
        tones[outcome],
      )}
    >
      {outcome === 'n/a' ? 'N/A' : outcome}
    </span>
  );
}
